<template>
  <SectionContainer :title="$t('home.intro.title')">
    <div
      class="w-full flex flex-1 max-w-4xl mx-auto gap-4 flex-wrap items-center justify-center"
    >
      <div class="flyer flyer-1 bg-deliver-bg">
          <h3 class="title">{{ $t('home.intro.head1') }}</h3>
          <p class="description">{{ $t('home.intro.desc1') }}</p>
        <div class="flex-1"></div>
        <img class="image" src="/homepage/Layer_x0020_1.png" alt="flyer" />
      </div> 

      <div class="flyer flyer-2 bg-offer-bg">
          <h3 class="title">{{ $t('home.intro.head2') }}</h3>
          <p class="description">{{ $t('home.intro.desc2') }}</p>
        <div class="flex-1"></div>
        <img class="image" src="/homepage/Layer_x0020_2.png" alt="flyer" />
      </div>
  
      <div class="flyer flyer-3 bg-basket-bg">
          <h3 class="title">{{ $t('home.intro.head3') }}</h3>
          <p class="description">{{ $t('home.intro.desc3') }}</p>
        <div class="flex-1"></div>
        <img class="image" src="/homepage/Layer_x0020_3.png" alt="flyer" />
      </div>
    </div>
  </SectionContainer>
</template>

<script setup lang="ts">
</script>

<style scoped lang="scss">

</style>
